import { PhotoSets } from '../translations-types';

const translations: PhotoSets = {
  title: 'Before/after photos',
  portalTitle: 'My photos',
  newSet: 'New photo set',
  noSets: 'No photo sets yet. Create a set with photos from every angle.',
  noSharedSets: 'No photos have been shared with you yet.',
  angleLeftProfile: 'Left profile',
  angleLeft45: '45° left',
  angleFront: 'Front',
  angleRight45: '45° right',
  angleRightProfile: 'Right profile',
  labelBefore: 'Before',
  labelAfter: 'After',
  labelProgress: 'Progress',
  noLabel: 'No label',
  pin: 'Pin to compare',
  unpin: 'Unpin',
  pinnedTitle: 'Pinned',
  pinHint: 'Pin sets to keep them on top and compare them.',
  otherSets: 'All sets',
  compare: 'Compare',
  sideBySide: 'Side by side',
  slider: 'Slider',
  compareHint: 'Pin two or more sets to compare them per angle.',
  editSet: 'Edit set',
  deleteSet: 'Delete set',
  deleteSetConfirm: 'Are you sure? The set and all its photos will be deleted.',
  deletePhotoConfirm: 'Delete this photo?',
  date: 'Date',
  appointment: 'Appointment',
  noAppointment: 'No appointment (free date)',
  label: 'Label',
  notes: 'Note',
  sharedWithCustomer: 'Visible to client',
  sharedHint: 'The client sees this set in the client portal.',
  sharedTag: 'Visible to client',
  notSharedTag: 'Salon only',
  shareConfirm: "Share this set with the client? It will appear under 'My photos'.",
  unshareConfirm: 'Stop showing this set to the client?',
  swapSides: 'Swap sides',
  saved: 'Saved',
  addPhotos: 'Take photos',
  retake: 'Retake',
  realign: 'Align',
  removePhoto: 'Delete photo',
  emptyAngle: 'No photo',
  captureTitle: 'Take photos',
  capture: 'Capture',
  uploadInstead: 'Upload photo',
  switchCamera: 'Switch camera',
  ghost: 'Previous photo',
  next: 'Next',
  previous: 'Previous',
  done: 'Done',
  uploading: 'Saving…',
  cameraError: 'Camera not available. You can upload a photo instead.',
  guideLoading: 'Loading face detection…',
  guideFaceNotFound: 'No face found',
  guideCloser: 'Move closer',
  guideFurther: 'Move a bit further away',
  guideTurnMore: 'Turn the head further',
  guideTurnLess: 'Turn the head back a little',
  guideGood: 'Good',
  alignTitle: 'Align photo',
  zoom: 'Zoom',
  rotation: 'Rotate',
  reference: 'Compare with',
  none: 'None',
  alignHint: 'Drag and zoom the photo so the head fits the guide.',
  autoAlign: 'Auto-align',
  autoAlignFailed: 'No face found; please align the photo manually.',
  reset: 'Reset',
  alignedAuto: 'Auto-aligned',
  alignedManual: 'Manually aligned',
  notAligned: 'Not aligned',
  uploadError: 'Saving the photo failed.',
  photosCount: '{{count}} of 5 photos',
  close: 'Close',
};

export default translations;
